import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { Formatters } from 'angular-slickgrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CustomInputEditor } from '../custom-inputEditor';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-enduser_approver_master_screen',
    templateUrl: './enduser_approver_master_screen.component.html',
    styleUrls: ['./enduser_approver_master_screen.component.css']
})
export class enduserApproverMasterScreenComponent implements OnInit, OnDestroy {

    displayed = true;
    subject: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    // =============================
    psno: string;
    username: string;
    phoneno: string;
    email: string;
    categories = [];
    tickets = [];
    ticketSelected: number;
    categorySelected: string;
    categoryName: string;
    ticket_type: string;
    priorities = [];
    prioritySelected: number;
    priority_name: string;
    categoryArr = [];
    dataLoaded: boolean;
    isShow = false;

    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    categrySelected: any;
    cats: any;
    userName: string;
    showExportBtn = true;
    isExportDisable = false;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    searchUser: FormControl = new FormControl();

    groupSelected: any;
    groups: any;

    constructor(private _rest: RestApiService, private messageService: MessageService,
        private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteApproverEnduserMaster({ user_id: this.messageService.getUserId(), id: item.id }).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });

        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.isShow = false;
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Enduser Approver Master Screen',
            openModalButton: 'Add Enduser Approver',
            searchModalButton: 'Search',
            breadcrumb: 'Enduser Approver Master',
            folderName: 'All Enduser Approver Master',
            tabName: 'Enduser Approver Master',
            exportBtn: 'Export to excel',

        };
        this.psno = '';
        this.username = '';
        this.phoneno = '';
        this.email = '';
        let columnDefinitions = [];
        columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'tkttyp', name: 'Ticket Type', field: 'tkttyp', sortable: true, filterable: true
            },
            {
                id: 'Approver_Group', name: 'Approver Group', field: 'Approver_Group', sortable: true, filterable: true
            },
            {
                id: 'roleName', name: 'Approver Role', field: 'roleName', sortable: true, filterable: true
            },
            {
                id: 'prev_status_id', name: 'Prev Approval Status', field: 'prev_status_id', sortable: true, filterable: true
            },
            {
                id: 'approver_status_seq', name: 'Next Approval Status', field: 'approver_status_seq', sortable: true, filterable: true
            },
            {
                id: 'approver', name: 'Approver', field: 'approver', sortable: true, filterable: true
            },
            {
                id: 'enduser', name: 'End User', field: 'enduser', sortable: true, filterable: true
            }

        ];

        this.messageService.setColumnDefinitions(columnDefinitions);

        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.getTableData();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.getTableData();
            });
        }
        this.searchUser.valueChanges.subscribe(
            psOrName => {
                this.isLoading = true;
                if (psOrName !== '') {
                    this._rest.getUserWithOrWithoutVendorMapping(this.clientId, false, 0, psOrName).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.EndUsers = this.respObject.details;

                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.EndUsers = [];
                    this.userName = '';
                    this.isLoading = false;
                }
            });

    }

    EndUsers = [];
    EndUserSelected: any;
    L3Users = [];
    L3UsersSelected: number;
    ApproverSpgId: number;
    statusSeq: any;
    statusSelected: any;
    onPageLoad() {
        this.dataLoaded = false;
        this.newstatusSeq = [];
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
                this.selectedTypeValue = 1;
                this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({ id: 0, name: 'Select Support Group' });
                        this.groups = this.respObject.details;
                        this.groupSelected = 0;
                        this.dataLoaded = true;
                        this._rest.getStatusForClient(this.clientId).subscribe((res2) => {
                            this.respObject = res2;
                            if (this.respObject.success) {
                                this.isError = false;
                                this.respObject.details.unshift({ id: 0, name: 'Select Approval Status' });
                                this.statusSeq = this.respObject.details;
                                this.statusSelected = 0;
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            this.notifier.notify('error', JSON.stringify(err));
                        });

                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                        this.dataLoaded = true;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                    this.dataLoaded = true;
                });

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.dataLoaded = true;
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
            this.dataLoaded = true;
        });

    }

    EndUserSelectedValue: any;
    getUserDetails() {
        for (let i = 0; i < this.EndUsers.length; i++) {
            if (this.EndUsers[i].login_name === this.EndUserSelectedValue) {
                this.EndUserSelected = this.EndUsers[i].id;
                this.userName = this.EndUsers[i].name;
            }
        }
    }

    roles = [];
    roleId: number;
    onChnageSenderType() {
        if (Number(this.selectedTypeValue) == 2) {
            this._rest.getRoleClientWise(this.clientId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.roles.unshift({ id: 0, name: 'Select Role' });
                    this.roles = this.respObject.roles;
                    console.log('--------- >>> ' + JSON.stringify(this.roles))
                    this.roleId = 0;
                    this.dataLoaded = true;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
                this.dataLoaded = true;
            });
        }
    }

    onroleChange() {
        this._rest.getUserByRole({ clientId: this.clientId, roleId: this.roleId }).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, name: 'Select User' });
                this.L3Users = this.respObject.details;
                this.L3UsersSelected = 0;
            } else {
            }
        }, (err) => {

        });
    }

    senderTypeObj = [{ id: 1, type_text: 'Approver By Support Group' }, { id: 2, type_text: 'Approver By User Role' }];
    selectedTypeValue: any;
    groupName: any;
    onGroupChange(selectedIndex: any) {

        this.groupName = this.groups[selectedIndex].name;

        this._rest.getUserByGroup(this.clientId, this.groups[selectedIndex].id).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Approver' });
                this.L3Users = this.respObject.details;
                this.L3UsersSelected = 0;
                this.dataLoaded = true;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.dataLoaded = true;
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
            this.dataLoaded = true;
        });

    }



    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.onPageLoad();
            this.L3UsersSelected = 0;
            this.ticketSelected = 0;
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onApproverChange(value: any) {
        this.ApproverSpgId = this.L3Users[value].spgID;
        console.log(JSON.stringify(this.L3Users[value]));
    }

    is_skip
    save() {
        const data = {
            clientId: this.clientId, tktType: this.ticketSelected,
            createdBy: this.messageService.getUserId(),
            enduser_id: this.EndUserSelected,
            approver_id: this.L3UsersSelected,
            selectedTypeValue: this.selectedTypeValue,
            prevstatusSelected: this.statusSelected,
            newstatusSelected: this.newstatusSelected
        };
        if (!this.messageService.isBlankField(data)) {

            if (this.selectedTypeValue === 2 || this.selectedTypeValue === '2') {
                data['roleId'] = this.roleId; 
            } else {
                data['approver_spg'] = this.groupSelected;
            }

            this._rest.addApproverEnduserMaster(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.ApproverSpgId = 0;
                   // this.EndUserSelected = 0;
                   // this.EndUserSelectedValue = '';
                    this.L3UsersSelected = 0;
                    //this.selectedTypeValue = 1;
                    this.L3UsersSelected = 0;
                    this.statusSelected = 0;
                    this.newstatusSelected = 0;
                    this.groupSelected = 0;
                    this.roleId = 0;
                    this.notifier.notify('success', 'End-user Mapped with Approver.....')
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                    this.notifier.notify('error', this.errorMessage)
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    newstatusSeq = [];
    newstatusSelected: any;
    onStatusChange() {
        this._rest.getNextStatus(this.clientId,
            this.ticketSelected, this.statusSelected).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.respObject.details.unshift({ id: 0, name: 'Select Status' });
                    this.newstatusSeq = this.respObject.details;
                    this.newstatusSelected = 0;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
            });
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getApproverEnduserMaster(offset, this.pageSize, paginationType, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }


    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
